import React, { ChangeEvent } from 'react';

import { Box, Button, Stack, Typography } from '@mui/joy';
import { observer } from 'mobx-react-lite';

import { missionPlannerStore } from '../../stores/MissionPlannerStore';
import type { SimpleItem } from '../../types/Plan';
import TakeoffSettings from './TakeoffSettings';
import WaypointSettings from './WaypointSettings';

const FileTool = () => {
  const handleUpload = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const plan = JSON.parse(reader.result as string);
        missionPlannerStore.loadPlan(plan);
      } catch (err) {
        console.error('Invalid plan file');
      }
    };
    reader.readAsText(file);
  };

  const download = () => {
    const dataStr = JSON.stringify(missionPlannerStore.exportPlan(), null, 2);
    const blob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'mission.plan';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Stack spacing={1}>
      <Typography level='title-sm'>File Operations</Typography>
      <Button size='sm' component='label'>
        Upload Plan
        <input hidden type='file' accept='.plan' onChange={handleUpload} />
      </Button>
      <Button onClick={download} size='sm'>
        Download Plan
      </Button>
      <Button onClick={() => missionPlannerStore.clearAll()} size='sm' color='danger'>
        Clear All
      </Button>
    </Stack>
  );
};

const ToolSettingsPanel: React.FC = () => {
  const { activeTool } = missionPlannerStore;

  if (activeTool === 'None') {
    return null; // Or show some default help text
  }

  return (
    <Box sx={{ p: 2 }}>
      {activeTool === 'File' && <FileTool />}
      {activeTool === 'Waypoint' && <WaypointSettings />}
      {/* Add other tools here */}
      {activeTool === 'Takeoff' && <TakeoffSettings />}
      {activeTool === 'Pattern' && <Typography>Pattern Settings...</Typography>}
      {activeTool === 'Return' && <Typography>Return to Launch Settings...</Typography>}
    </Box>
  );
};

export default observer(ToolSettingsPanel);
